import React from 'react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
import { PackagePricing } from '../components/PackagePricing';
import { FeatureItem } from '../components/FeatureItem';
import { RelatedLinks } from '../components/RelatedLinks';
import { packages } from '../data/packages';
const pkg = packages.find(p => p.slug === 'full-detail')!;
const faqs = [{
  question: 'What is included in a full car detail?',
  answer: 'A full detail combines our complete interior and exterior services: deep vacuuming, shampooing, steam sanitizing, leather conditioning, a safe hand wash, clay bar decontamination, wheel and tire detailing, and premium paint protection.'
}, {
  question: 'How long does a full detail take?',
  answer: 'A full detail typically takes 3\u20134 hours depending on the size and condition of your vehicle. We never rush \u2014 quality results take proper time and attention.'
}, {
  question: 'How much does a full car detail cost?',
  answer: 'Our full detail is $300 for small and mid-size vehicles and $350 for SUVs and crossovers. Call or text (818) 381-9905 for an exact quote.'
}, {
  question: 'Is a full detail worth it before selling my car?',
  answer: 'Absolutely. A full detail is one of the most cost-effective ways to maximize resale value, presenting your vehicle in its best possible condition inside and out.'
}, {
  question: 'Do you come to my home or office for a full detail?',
  answer: 'Yes. We are fully mobile, bringing our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
}];
export function FullDetailPage() {
  return <ServicePageLayout title="Full Detail" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Mobile Full Detail in Ventura County — complete interior deep clean plus exterior wash, clay bar and hybrid ceramic spray. $300 SM/Mid, $350 SUV. Call or text 818-381-9905." schema={{
    '@type': 'Service',
    name: 'Full Detail',
    serviceType: 'Mobile Full Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail"
    },
    areaServed: ['Ventura County', 'Camarillo', 'Ventura', 'Thousand Oaks'],
    description: 'Complete mobile full car detailing combining deep interior cleaning with an exterior wash, clay bar treatment, and hybrid ceramic spray protection.',
    offers: [{
      '@type': 'Offer',
      price: '300',
      priceCurrency: 'USD',
      description: 'Small / mid-size vehicle'
    }, {
      '@type': 'Offer',
      price: '350',
      priceCurrency: 'USD',
      description: 'SUV / crossover'
    }]
  }} faqs={faqs} breadcrumbs={[{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Full Detail',
    item: 'https://www.fulldetailpro.com/full-detail'
  }]} data-id="element-866" data-mp="221a2uk7o4e97">
      <p data-id="element-867" data-mp="3banszh0egj0m">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-868" data-mp="36c2xfuw3enii">Full Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing — delivered directly to your driveway or workplace
        anywhere in Ventura County.
      </p>

      <PackagePricing pkg={pkg} data-id="element-869" data-mp="2nka1pspn2o73" />

      <figure className="not-prose my-10" data-id="element-870" data-mp="2nl3at0c2lpse">
        <img src="https://cdn.magicpatterns.com/uploads/ned8mdPgcS8nYQ5VpmCn7T/Red_BMW_.jpg" alt="Red BMW M4 convertible after a mobile full detail with a showroom shine" loading="lazy" decoding="async" className="w-full h-auto rounded-xl border border-zinc-800" data-id="element-871" data-mp="31b6srf3x2xc1" />
      </figure>

      <h2 data-id="element-872" data-mp="23v9eqa2booid">What Goes Into a Full Detail</h2>
      <p data-id="element-873" data-mp="23u84g7t4s61p">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-874" data-mp="2mg9ubv4h4klc">Exterior Services</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-875" data-mp="2mhcnk9p9qz4f">
        <FeatureItem data-id="element-876" data-mp="2rfmicj72zxpi">Wash method to safely remove surface dirt and grime.</FeatureItem>
        <FeatureItem data-id="element-877" data-mp="2w6mgtsvumnu4">
          <strong data-id="element-878" data-mp="2w74nljg50kga">Decontamination & Clay Bar:</strong> Removal of embedded iron
          particles, tree sap, and road tar to leave the paint smooth.
        </FeatureItem>
        <FeatureItem data-id="element-879" data-mp="357au2ldf4k5y">
          <strong data-id="element-880" data-mp="356rlvwdkla54">Wheel & Tire Detail:</strong> Deep cleaning of wheel barrels,
          faces, and tires, finished with a premium no-sling dressing.
        </FeatureItem>
        <FeatureItem data-id="element-881" data-mp="3f5qk0l0plndv">
          <strong data-id="element-882" data-mp="3f60dwjovkeou">Paint Protection:</strong> Application of a{' '}
          <Link to="/services/hybrid-ceramic-spray" data-id="element-883" data-mp="3f3e6ql5wc175">hybrid ceramic spray</Link>{' '}
          for gloss and water beading.
        </FeatureItem>
      </ul>

      <h3 data-id="element-884" data-mp="1ksimgllcmxoj">Interior Services</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-885" data-mp="1kttsks29ohit">
        <FeatureItem data-id="element-886" data-mp="1xmu3j3wdxoq">
          <strong data-id="element-887" data-mp="1y5z5z8g8rlc">Deep Vacuuming:</strong> Thorough removal of dirt and pet
          hair, followed by steam cleaning carpets and cloth seats.
        </FeatureItem>
        <FeatureItem data-id="element-888" data-mp="3p8vxnj0e64so">
          <strong data-id="element-889" data-mp="3pagu5e69nxt6">Leather Treatment:</strong> Gentle cleaning and premium
          conditioning to restore softness and prevent cracking.
        </FeatureItem>
        <FeatureItem data-id="element-890" data-mp="kv76hqph73sg">
          <strong data-id="element-891" data-mp="kvqo16b7rq5y">Surface Sanitization:</strong> Steam cleaning of vents, cup
          holders, and dashboard to kill bacteria and remove sticky residues.
        </FeatureItem>
        <FeatureItem data-id="element-892" data-mp="buiv73rgvhj9">
          <strong data-id="element-893" data-mp="btzjw5wbnre7">Crystal Clear Glass:</strong> Streak-free cleaning of all
          interior and exterior windows and mirrors.
        </FeatureItem>
      </ul>

      <h2 data-id="element-894" data-mp="2wl03om27iqzl">The Ultimate Value and Convenience</h2>
      <p data-id="element-895" data-mp="2wlt1uyn3o864">
        Booking a Full Detail is the most cost-effective way to completely reset
        your vehicle's condition. Whether you are preparing to sell your car,
        returning a lease, or simply want to fall in love with your daily driver
        all over again, this package delivers unmatched results. Because we are
        a fully mobile operation, you don't have to waste your day in a waiting
        room. We bring our own water and detailing equipment, and we require
        access to a standard electrical outlet at the service location.
      </p>

      <h2 data-id="element-896" data-mp="2ac2s7pdp3plr">Related Services</h2>
      <RelatedLinks links={[['/wash-wax', 'Wash & Wax'], ['/services/interior-detailing', 'Interior Detailing'], ['/services/engine-bay-detailing', 'Engine Bay Detailing'], ['/specials', 'Current Specials']]} data-id="element-897" data-mp="2abt0nxd05ady" />
    </ServicePageLayout>;
}